<template>
<div>
    <gform :props="props" :formname="formname" :rowdata="rowdata" :formmodel="'batchmodify'" :thetext="thetext"></gform>
</div>
</template>

<script>
import gform from "./gform"
export default {
    components:{gform},
    props: ["props", "rowdata","formname","thetext"],
    data(){
        return {
 
        }
    }
    
}
</script>


// WEBPACK FOOTER //
// src/components/utility/commonfields/form/batchmodifyform.vue